<template>
  <div>
    <div class="flex min-h-screen max-h-screen flex-col">
      <div class="flex mx-auto p-4 w-full justify-center">
        <div class="flex w-full justify-center">
          <div class="w-auto min-w-50">
            <div class="border border-white">
              <form
                v-if="!showforgetpassword"
                @submit.prevent="login"
                class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
              >
                <h1 class="text-2xl mb-8">Login</h1>
                <p class="text-red-400 mb-4" v-if="getAuth.noPermission">
                  Your account does not have the right permissions for this
                  portal
                </p>
                <div class="mb-4">
                  <label
                    class="block text-gray-700 text-sm font-bold mb-2"
                    for="username"
                  >
                    E-mail
                  </label>
                  <input
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="username"
                    type="email"
                    placeholder="E-mail"
                    v-model="username"
                    required="required"
                  />
                </div>
                <div class="">
                  <label
                    class="block text-gray-700 text-sm font-bold mb-2"
                    for="password"
                  >
                    Password
                  </label>
                  <input
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                    id="password"
                    type="password"
                    placeholder="******************"
                    v-model="password"
                    required="required"
                  />
                </div>
                <div class="h-10">
                  <p class="text-red-400" v-if="getAuth.authenticationError">
                    Invalid e-mail or password
                  </p>
                </div>
                <div class="flex items-center justify-between">
                  <input
                    class="bg-blue-800 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    type="submit"
                    value="Sign In"
                  />
                  <a
                    class="inline-block align-baseline font-bold text-sm text-blue-800 hover:text-blue-800"
                    @click.prevent="showforgetpassword = true"
                    href="#"
                  >
                    Forgot Password?
                  </a>
                </div>
              </form>
              <div v-else>
                <form
                  @submit.prevent="forgotpassword"
                  class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
                  v-if="resetPasswordStep == 0"
                >
                  <h1 class="text-2xl mb-8">Forgot Password</h1>
                  <div class="mb-4">
                    <label
                      class="block text-gray-700 text-sm font-bold mb-2"
                      for="username"
                    >
                      E-mail
                    </label>
                    <input
                      class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      id="username"
                      type="email"
                      placeholder="E-mail"
                      v-model="username"
                      required="required"
                    />
                  </div>
                  <div class="flex items-center justify-between">
                    <input
                      class="bg-blue-800 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      type="submit"
                      value="Request Password Reset"
                    />
                    <a
                      class="inline-block align-baseline font-bold text-sm text-blue-800 hover:text-blue-800"
                      @click.prevent="showforgetpassword = false"
                      href="#"
                    >
                      Login instead?
                    </a>
                  </div>
                </form>
                <form
                  @submit.prevent="resetpassword"
                  class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
                  v-if="resetPasswordStep == 1"
                >
                  <h1 class="text-2xl mb-2">Password Reset</h1>
                  <p class="mb-8">
                    Use the code from the password reset email and reset your
                    password.
                  </p>
                  <div class="mb-4">
                    <label
                      class="block text-gray-700 text-sm font-bold mb-2"
                      for="resetcode"
                    >
                      Password reset code
                    </label>
                    <input
                      class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      id="resetcode"
                      type="text"
                      placeholder="Reset code"
                      v-model="resetcode"
                      required="required"
                    />
                  </div>
                  <div class="mb-4">
                    <label
                      class="block text-gray-700 text-sm font-bold mb-2"
                      for="password"
                    >
                      New Password
                    </label>
                    <input
                      class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      id="password"
                      type="password"
                      placeholder="New password"
                      v-model="password"
                      required="required"
                    />
                  </div>
                  <div class="flex items-center justify-between">
                    <input
                      class="bg-blue-800 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      type="submit"
                      value="Send Password Reset"
                    />
                    <a
                      class="inline-block align-baseline font-bold text-sm text-blue-800 hover:text-blue-800"
                      @click.prevent="showforgetpassword = false"
                      href="#"
                    >
                      Login instead?
                    </a>
                  </div>
                </form>
              </div>
              <p class="text-center text-gray-500 text-xs">
                &copy;2020 Tailie. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      resetcode: "",
      showforgetpassword: false,
      resetPasswordStep: 0
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getAuthLoggedIn"])
  },
  methods: {
    login() {
      const value = btoa(`${this.username}:${this.password}`);
      this.$store.dispatch("authenticate", value);
    },
    forgotpassword() {
      this.$store.dispatch("requestpasswordreset", this.username).then(() => {
        this.resetPasswordStep = 1;
      });
    },
    resetpassword() {
      this.$store
        .dispatch("resetpassword", {
          email: this.username,
          password: this.password,
          code: this.resetcode
        })
        .then(() => {
          this.resetPasswordStep = 0;
          this.showforgetpassword = false;
          this.resetcode = "";
        });
    }
  },
  watch: {
    getAuthLoggedIn() {
      if (this.getAuthLoggedIn) {
        this.$router.push({
          name: "queue"
        });
      }
    }
  }
};
</script>
